"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stepsValues = exports.steps = void 0;

var R = _interopRequireWildcard(require("ramda"));

var steps = {
  GIFT_LINK: 'gift_link',
  SELECT_CAMPAIGN: 'select_campaign',
  PROCESSING: 'processing',
  SELECT_PRODUCT: 'select_product',
  SELECT_INVITATION_TYPE: 'select_invitation_type',
  SELECT_TEMPLATE: 'select_template',
  EDIT_TEMPLATE_MESSAGE: 'edit_template_message',
  REVIEW: 'review',
  VIDEO_LANDING_PAGE: 'video_landing_page',
  REQUIREMENTS: 'requirements',
  DETAILS: 'details',
  NEED_MORE_INFO: 'need_more_info'
};
exports.steps = steps;
var stepsValues = R.values(steps);
exports.stepsValues = stepsValues;